export const SET_CERT_REQUEST_FILE = "SET_CERT_REQUEST_FILE";
export const CLEAR_CERT_REQUEST_FILE = "CLEAR_CERT_REQUEST_FILE";
